import * as CONSTRUCTOR from '../../generate';

export const requestRefundResponse = CONSTRUCTOR.FRAGMENT({
  name: 'RequestRefundResponse',
  fragmentName: 'RequestRefundResponseFields',
  fields: `{
    success
    message
  }`,
});
